import { FC } from 'react';

const Slider: FC<{
  value: number;
  max: number;
  min?: number;
  step?: number;
  className?: string;
  onChange: (value: number) => void;
}> = ({
  value,
  max,
  min = 0,
  step = 1,
  className,
  onChange
}: {
  value: number;
  max: number;
  min?: number;
  step?: number;
  className?: string;
  onChange: (value: number) => void;
}) => {
  const handleChange = (event: any) => {
    const value = +event.target.value;
    onChange(value);
  };

  return (
    <>
      <input
        id="slider-default"
        type="range"
        min={min}
        max={max}
        value={value}
        onChange={handleChange}
        step={step}
        className={`appeareance-none ${className ?? ''}`}
      />
    </>
  );
};

export default Slider;
